import { useMutation } from "@tanstack/react-query";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

type GenerateReportRequest = {
  url: string;
  notificationMessage: string;
};

export const useGenerateReport = () => {
  const request = useApi();
  const notification = useNotification();
  return useMutation<DefaultOperationSuccessResponse, Error, GenerateReportRequest>({
    mutationFn: ({ url }: GenerateReportRequest) => request(url, { method: "POST" }),
    onSuccess: async (response: DefaultOperationSuccessResponse, { notificationMessage }: GenerateReportRequest) => {
      if (response?.data && response.data.length > 0 && response.data[0]?.success === true) {
        notification.success({
          message: notificationMessage,
          placement: "bottomRight",
        });
      }
    },
  });
};
